export const EARTH_RADIUS_MILES = 3959;

const GEO_CENTER_LAT = 39.8283;
const GEO_CENTER_LNG = -98.5795;

export type FillOrigin = { latitude: number; longitude: number };

export function isGeoCenterSentinel({ latitude, longitude }: FillOrigin) {
  return (
    Math.abs(latitude - GEO_CENTER_LAT) < 0.01 &&
    Math.abs(longitude - GEO_CENTER_LNG) < 0.01
  );
}

export function haversineMiles(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
): number {
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const haversine =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2;
  return EARTH_RADIUS_MILES * 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
}

export function fillDistanceMiles(
  origin: FillOrigin,
  point: FillOrigin,
): number | null {
  if (isGeoCenterSentinel(point)) return null;
  return haversineMiles(
    origin.latitude,
    origin.longitude,
    point.latitude,
    point.longitude,
  );
}

export function compareFillDistance(
  left: { distanceMiles: number | null },
  right: { distanceMiles: number | null },
): number {
  if (left.distanceMiles !== null && right.distanceMiles !== null) {
    return left.distanceMiles - right.distanceMiles;
  }
  if (left.distanceMiles !== null) return -1;
  if (right.distanceMiles !== null) return 1;
  return 0;
}
